import type { TimeOfDay } from '../features/profile/finderSettings/types'

export interface TimeOfDayItem {
  /** Full label, e.g. "Mornings". */
  name: TimeOfDay
  /** Display order, earliest first. */
  index: number
  /** Stored/submitted value — same as the full name. */
  value: TimeOfDay
  /** Short label for compact UI (chips, card), e.g. "Morn". */
  short: string
}

export const TIMES_OF_DAY: TimeOfDayItem[] = [
  { name: 'Mornings', index: 1, value: 'Mornings', short: 'Morn' },
  { name: 'Afternoons', index: 2, value: 'Afternoons', short: 'Aft' },
  { name: 'Evenings', index: 3, value: 'Evenings', short: 'Eve' },
]
